import { render, staticRenderFns } from "./InsUserIner.vue?vue&type=template&id=655bace3&scoped=true&"
import script from "./InsUserIner.vue?vue&type=script&lang=ts&"
export * from "./InsUserIner.vue?vue&type=script&lang=ts&"
import style0 from "./InsUserIner.vue?vue&type=style&index=0&id=655bace3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655bace3",
  null
  
)

export default component.exports